// extracted by mini-css-extract-plugin
module.exports = {"card":"_025a50318d--card--gNnIx","title":"_025a50318d--title--zK6PE","description":"_025a50318d--description--S2VTz","button":"_025a50318d--button--2-8Bw"};